/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function LegislationAndRegulationInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Legislation Concerning Elections in Nova Scotia"
              description={
                <>
                  Elections in Nova Scotia are governed by provincial legislation. When delivering elections and related activities, we are responsible to obey and uphold all laws pertaining to elections in our province. <br /><br />
                  As an independent, non-partisan agency with a mandate is to conduct provincial general elections and by-elections, Elections Nova Scotia is primarily responsible for the administration of the <a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><em>Elections Act</em></a>.<br /><br />
                  {/* Amendments to the Elections Act made by Chapter 8 of the Acts of 2020 were proclaimed in effect on May 6, 2021. Please click here for more details on these <a href="https://electionsnovascotia.ca/LegislativeAmendments"> legislative amendments</a>.<br /><br /> */}
                  Please see the menu below to access other legislation pertaining to elections and the political process:<br /><br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf">House of Assembly Act</a></li>
                    <li><a href="http://nslegislature.ca/legc/statutes/income%20tax.pdf">Income Tax Act</a></li>
                    <li><a href="https://nslegislature.ca/sites/default/files/legc/statutes/controverted%20elections.pdf">Controverted Elections Act</a></li>
                    <li><a href="http://laws-lois.justice.gc.ca/eng/Const/index.html">Canadian Charter of Rights and Freedoms</a></li>
                    <li><a href="http://nslegislature.ca/legc/statutes/freedom%20of%20information%20and%20protection%20of%20privacy.pdf">Freedom of Information and Protection of Privacy Act</a></li>
                    <li><a href="http://nslegislature.ca/legc/statutes/human%20rights.pdf">Human Rights Act</a></li>
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default LegislationAndRegulationInformation;
